<script>
import Checkbox from "@/components/ui/Checkbox.vue";

export default {
    name: "TableContent",
    components: { Checkbox },
    props: {
        multiselect: Boolean,
        headers: {
            type: Object,
            default: () => ({}),
        },
        data: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            selected: [],
        };
    },
    computed: {
        isAllSelected() {
            return this.selected.length === this.data.length;
        },
    },
    methods: {
        toggleAll(event) {
            this.selected = event ? [...this.data] : [];
            this.$emit("update:selected", this.selected);
        },
        toggleRow(item) {
            if (this.isSelected(item)) {
                this.selected = this.selected.filter((i) => i !== item);
            } else {
                this.selected.push(item);
            }
            this.$emit("update:selected", this.selected);
        },
        isSelected(item) {
            return this.selected.includes(item);
        },
    },
};
</script>


<template>
    <div class="table-wrapper">
        <div class="table-content">
            <div v-if="multiselect" class="column w-fit">
                <div class="header-cell">
                    <Checkbox :checked="isAllSelected" @change="toggleAll" />
                </div>
                <div class="cell" v-for="(item, index) in data" :key="'chk' + index">
                    <Checkbox :checked="isSelected(item)" @change="toggleRow(item)" />
                </div>
            </div>
            <div class="column" v-for="(label, key) in headers" :key="key">
                <div class="header-cell">
                    {{ label }}
                </div>
                <div class="cell" v-for="(item, rowIndex) in data" :key="rowIndex + '-' + key">
                    <slot :name="key" :value="item[key]" :row="item">
                        {{ item[key] }}
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>


<style scoped lang="scss">
.table-wrapper {
    width: 100%;
    overflow-x: auto;

    .table-content {
        display: flex;
        flex-direction: row;
        align-items: flex-start;

        min-width: max-content;
        @media (min-width: 768px) {
            min-width: 100%;
            width: 100%;
        }
    }
}

.table-content {
    .column {
        display: flex;
        flex-direction: column;
        /*min-width: 160px;*/
        min-width: fit-content;
        flex: none;
        @media (min-width: 768px) {
            flex: 1;
        }
        .header-cell {
            box-sizing: border-box;
            padding: 12px 24px;
            min-height: 72px;
            background: #fafafa;
            border-bottom: 1px solid #e9eaeb;
            font-family: Geist, sans-serif;
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            color: #717680;
            display: flex;
            align-items: center;
        }

        .cell {
            box-sizing: border-box;
            padding: 16px 24px;
            height: 72px;
            min-height: 72px;
            border-bottom: 1px solid #e9eaeb;
            display: flex;
            align-items: center;
        }

        &:last-child .cell {
            padding: 16px;
        }
    }

    .column.w-fit {
        min-width: fit-content;
        position: sticky;
        left: 0;
        background: white;
        z-index: 2;
    }
}

</style>
